import { lazyPage, type ModulePlugin } from "@keel/core";
import { AwayTile } from "./Tile";

const people = () => import("./People");
const EmployeesList = lazyPage(people, "EmployeesList");
const EmployeePage = lazyPage(people, "EmployeePage");
const NewEmployee = lazyPage(people, "NewEmployee");
const Absences = lazyPage(() => import("./Absences"), "Absences");
const OrgChart = lazyPage(() => import("./OrgChart"), "OrgChart");

/** HR (optional module): employees, pay history, absences with approval, org chart. */
const plugin: ModulePlugin = {
  key: "hr",
  records: { Employee: "/people/" },
  help: () => import("./help"),
  nav: [
    {
      group: "People",
      items: [
        { to: "/people", label: "Employees", icon: "users", perm: "hr.employees.read" },
        { to: "/absences", label: "Absences", icon: "calendar", perm: "hr.employees.read" },
        { to: "/org-chart", label: "Org chart", icon: "grid", perm: "hr.employees.read" },
      ],
    },
  ],
  routes: [
    { path: "/people", element: <EmployeesList /> },
    { path: "/people/new", element: <NewEmployee /> },
    { path: "/people/:id", element: <EmployeePage /> },
    { path: "/absences", element: <Absences /> },
    { path: "/org-chart", element: <OrgChart /> },
  ],
  commands: [
    ["Employees", "/people", "users", "hr.employees.read"],
    ["Hire someone", "/people/new", "plus", "hr.employees.write"],
    ["Absences & vacations", "/absences", "calendar", "hr.employees.read"],
    ["Org chart", "/org-chart", "grid", "hr.employees.read"],
  ],
  dashboardTiles: [{ key: "hr", section: "hr", perm: "hr.employees.read", component: AwayTile }],
};
export default plugin;
